import rehypeParse from "rehype-parse";
import rehypeRemark from "rehype-remark";
import rehypeStringify from "rehype-stringify";
import remarkParse from "remark-parse";
import remarkRehype from "remark-rehype";
import remarkStringify from "remark-stringify";
import { unified } from "unified";
export const markdownToHtml = (markdownText) => {
    const file = unified()
        .use(remarkParse)
        .use(remarkRehype)
        .use(rehypeStringify)
        .processSync(markdownText);
    return String(file);
};
export const htmlToMarkdown = (htmlText) => {
    let input = htmlText;
    while (input.indexOf("<em> ") > -1 || input.indexOf(" </em>") > -1 || input.indexOf("<strong> ") > -1 || input.indexOf(" </strong>") > -1) {
        input = input.replaceAll("<em> ", " <em>")
            .replaceAll(" </em>", "</em> ")
            .replaceAll("<strong> ", " <strong>")
            .replaceAll(" </strong>", "</strong> ");
    }
    const file = unified()
        .use(rehypeParse, { fragment: true })
        .use(rehypeRemark)
        .use(remarkStringify)
        .processSync(input);
    return String(file);
};
